export const WHITE_STACKED =
  "https://media.nuskin.com/m/4e2c54902dbe08c0/original/ns_logo_stacked_white.svg";
export const WHITE_HORIZONTAL =
  "https://media.nuskin.com/m/132f5e02f400a49b/original/ns_logo_horizontal_white.svg";
export const WHITE_MARK =
  "https://media.nuskin.com/m/2cd1a372f0dfcad7/original/ns_logo_mark_white.svg";
export const WHITE_WORD_MARK =
  "https://media.nuskin.com/m/24f381259f0433cc/original/ns_word_mark_white.svg";
export const WHITE_POWERED_BY =
  "https://media.nuskin.com/m/7e9bb21de79e68c0/original/ns_powered_by_logo_white.svg";
export const DARK_STACKED =
  "https://media.nuskin.com/m/2b846d261b12a160/original/Nu-Skin-logo-stacked.svg";
export const DARK_HORIZONTAL =
  "https://media.nuskin.com/m/42085f266d4f93f0/original/Nu-Skin-Logo-Horizontal.svg";
export const DARK_MARK =
  "https://media.nuskin.com/m/2aff69b86ee23dfa/original/ns_logo_mark_dark.svg";
export const DARK_WORD_MARK =
  "https://media.nuskin.com/m/14e7ba1337632a3c/original/ns_word_mark_dark.svg";
export const DARK_POWERED_BY =
  "https://media.nuskin.com/m/28d3d689900a013a/original/ns_powered_by_logo_dark.svg";
